import { RoleName } from "../../constants";
import { usePickUserPermissions, useUserRoleSelector } from "../../store";
import { UserPermissionType } from "../../store/types/user-management";

export const useCanCreateDeal = (): boolean => {
  const role = useUserRoleSelector();
  const access = usePickUserPermissions("deals");

  if (!role) return false;

  if (role.name === RoleName.Admin) return true;

  return access !== UserPermissionType.VIEWER && access !== UserPermissionType.NO_ACCESS;
};
